import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, PrinterIcon } from 'lucide-react';
import { site, images } from '../data/site';
import { counties } from '../data/serviceAreas';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-ink text-steel-300" data-id="element-107" data-mp="36oxzd51dvozy">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-108" data-mp="36ppk1ktg02bg" />
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-2 lg:grid-cols-4" data-id="element-109" data-mp="3uesczotj1hl9">
        <div data-id="element-110" data-mp="38za4uuqp54h">
          <div className="bg-white/95 inline-block rounded-sm p-3" data-id="element-111" data-mp="37o6qw57hzdw">
            <img src={site.logo} alt="TOTAL Home Improvement logo" className="h-14 w-auto" data-id="element-112" data-mp="3lelz41tx2flk" />
          </div>
          <p className="mt-4 text-sm leading-relaxed" data-id="element-113" data-mp="3qfjighqnxfon">
            Full service, licensed and insured builder serving southeast
            Michigan. Repair, update, renovate — inside and outside, all four
            seasons of the year.
          </p>
          <div className="mt-5 flex items-center gap-3" data-id="element-114" data-mp="3l8qwa43iojrg">
            <img src={images.bbb} alt="Better Business Bureau" className="h-10 w-auto bg-white p-1" data-id="element-115" data-mp="3lbddkvg7mdmv" />
            <img src={images.epa} alt="Lead Safe EPA Certified" className="h-10 w-auto bg-white p-1" data-id="element-116" data-mp="3v8hqe4o60wr0" />
          </div>
        </div>

        <div data-id="element-117" data-mp="828mq5huy395">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-118" data-mp="81pg3kxnr1af">
            Contact
          </h2>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-119" data-mp="31uotg9z09ou">
            <li data-id="element-120" data-mp="ht3d9m24zp0e">
              <a href={site.estimatePhone.href} className="flex items-start gap-2.5 transition hover:text-white" data-id="element-121" data-mp="hrihxu80021h">
                <PhoneIcon className="mt-0.5 h-4 w-4 text-safety" aria-hidden="true" data-id="element-122" data-mp="qt04nvfwv1z5" />
                <span data-id="element-123" data-mp="mrwm316haru8">
                  <span className="block font-bold text-white" data-id="element-124" data-mp="mspnrnqkyr5i">
                    {site.estimatePhone.display}
                  </span>
                  <span className="text-xs uppercase tracking-wide" data-id="element-125" data-mp="twxv9kvlbuel">
                    Free estimates
                  </span>
                </span>
              </a>
            </li>
            <li data-id="element-126" data-mp="13sirt3hw42gy">
              <a href={site.plumbingPhone.href} className="flex items-start gap-2.5 transition hover:text-white" data-id="element-127" data-mp="13rzk0flyeugn">
                <PhoneIcon className="mt-0.5 h-4 w-4 text-safety" aria-hidden="true" data-id="element-128" data-mp="1cmdywh2ko2z8" />
                <span data-id="element-129" data-mp="1hk5wnrpwejbc">
                  <span className="block font-bold text-white" data-id="element-130" data-mp="1hje1uj44kpm4">
                    {site.plumbingPhone.display}
                  </span>
                  <span className="text-xs uppercase tracking-wide" data-id="element-131" data-mp="1mhxpqp2a4bh4">
                    Plumbing line
                  </span>
                </span>
              </a>
            </li>
            <li data-id="element-132" data-mp="3oczo179lsb4g">
              <a href={site.emailHref} className="flex items-start gap-2.5 break-all transition hover:text-white" data-id="element-133" data-mp="3odhwr3dgcht9">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-134" data-mp="2afwz4q22lr18" />
                {site.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-135" data-mp="21mjyt31ofn54">
              <PrinterIcon className="mt-0.5 h-4 w-4 text-safety" aria-hidden="true" data-id="element-136" data-mp="21n1unykffzci" />
              Fax {site.fax}
            </li>
            <li className="flex items-start gap-2.5" data-id="element-137" data-mp="2tdzj2qfrgxs6">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-138" data-mp="2tdg1jau0wbeo" />
              <span data-id="element-139" data-mp="2pdpf1jbj4hfy">
                {site.address.company}
                <br data-id="element-140" data-mp="2kd1i6h0md6dt" />
                {site.address.line1}
                <br data-id="element-141" data-mp="2kbgn8qae7lff" />
                {site.address.city}, {site.address.state} {site.address.zip}
              </span>
            </li>
          </ul>
        </div>

        <div data-id="element-142" data-mp="18z5yqw2ombgs">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-143" data-mp="18yxprf9ojqav">
            Popular Services
          </h2>
          <ul className="mt-4 grid gap-2 text-sm" data-id="element-144" data-mp="2rvr8jib0yugx">
            {services.slice(0, 9).map(s => <li key={s.slug} data-id="element-145" data-mp="2wmfxoqz8ffcw">
                <Link to={`/services/${s.slug}`} className="transition hover:text-safety" data-id="element-146" data-mp="2wmpoggs3pqjn">
                  {s.name}
                </Link>
              </li>)}
            <li data-id="element-147" data-mp="2nunr4rdbwqdl">
              <Link to="/services" className="font-semibold text-safety" data-id="element-148" data-mp="2ns1mazhtooz2">
                View all services →
              </Link>
            </li>
          </ul>
        </div>

        <div data-id="element-149" data-mp="3fk0m5wy34bwz">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-150" data-mp="3fkisxnidi8j5">
            Service Area
          </h2>
          <p className="mt-4 text-sm leading-relaxed" data-id="element-151" data-mp="36kdljdd6ja4z">
            {counties.join(', ')} Counties, Michigan.
          </p>
          <Link to="/service-area" className="mt-3 inline-block text-sm font-semibold text-safety hover:underline" data-id="element-152" data-mp="1q646xayqozrc">
            See every city we cover →
          </Link>

          <h2 className="mt-8 font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-153" data-mp="1nkwjcaf1nehg">
            Find Us
          </h2>
          <ul className="mt-3 space-y-2 text-sm" data-id="element-154" data-mp="1ioz2m2zvc645">
            <li data-id="element-155" data-mp="1wmw2b89mcsn1">
              <a href={site.social.facebook} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-156" data-mp="1wlckvec88bjo">
                Facebook
              </a>
            </li>
            <li data-id="element-157" data-mp="zwn09g97t4u0">
              <a href={site.social.houzz} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-158" data-mp="zx68u6cz6gvd">
                Houzz profile
              </a>
            </li>
            <li data-id="element-159" data-mp="18v8gh4r7s7rm">
              <a href={site.social.bbb} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-160" data-mp="l77c8812jdi0">
                BBB profile
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-161" data-mp="2l9qc7j91tn6n">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-xs sm:flex-row sm:items-center sm:justify-between" data-id="element-162" data-mp="2l8f97lnfgjgl">
          <p data-id="element-163" data-mp="2q2sz58jblydv">
            © {new Date().getFullYear()} Total Home Improvement. All rights
            reserved.
          </p>
          <div className="flex gap-5" data-id="element-164" data-mp="1xc178n9afvwc">
            <Link to="/privacy" className="hover:text-white" data-id="element-165" data-mp="1xd2s1jg3vwr9">
              Privacy Policy
            </Link>
            <Link to="/contact" className="hover:text-white" data-id="element-166" data-mp="22be1ht2ho58y">
              Request an Estimate
            </Link>
          </div>
        </div>
      </div>
      <div className="h-16 lg:hidden" aria-hidden="true" data-id="element-167" data-mp="2bc28w4xdn7cv" />
    </footer>;
}